// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notice-section {
  padding: 6rem 0;
}
.notice-section .notices-update-btn-container {
  position: relative;
}
.notice-section .notices-update-btn-container .add-btn {
  position: absolute;
  right: 1rem;
  top: 30px;
}

.notices-update-section .custom-container .content-section {
  background: #E0E7FF;
  padding: 4rem 2rem;
  min-height: 55vh;
  font-family: "Roboto", "SolaimanLipi", sans-serif;
}
.notices-update-section .custom-container .content-section .page-title {
  font-size: 2.2rem;
  text-align: center;
  color: #08245A;
}
.notices-update-section .custom-container .content-section .page-title::after {
  content: "";
  display: block;
  height: 8px;
  width: 60px;
  background: #08245A;
  margin: 0.7rem auto 0;
  border-radius: 20px;
}
.notices-update-section .custom-container .content-body {
  margin: 3rem auto 0;
  max-width: 1200px !important;
}

.text-ellipsis-100px {
  max-width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
  margin-left: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/adminPages/home/notices.scss","webpack://./src/assets/css/common/_variables.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;AADF;AAGE;EACE,kBAAA;AADJ;AAGI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AADN;;AAUI;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;AAPN;AASM;EACE,iBCdK;EDeL,kBAAA;EACA,cAAA;AAPR;AASQ;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;AAPV;AAYI;EACE,mBAAA;EACA,4BAAA;AAVN;;AAeA;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;AAZF","sourcesContent":["@import \"../../../../assets/css/common/variables\";\r\n\r\n.notice-section {\r\n  padding: 6rem 0;\r\n\r\n  .notices-update-btn-container {\r\n    position: relative;\r\n\r\n    .add-btn {\r\n      position: absolute;\r\n      right: 1rem;\r\n      top: 30px;\r\n    }\r\n  }\r\n}\r\n\r\n.notices-update-section {\r\n\r\n  .custom-container {\r\n\r\n    .content-section {\r\n      background: #E0E7FF;\r\n      padding: 4rem 2rem;\r\n      min-height: 55vh;\r\n      font-family: \"Roboto\", \"SolaimanLipi\", sans-serif;\r\n\r\n      .page-title {\r\n        font-size: $page-title;\r\n        text-align: center;\r\n        color: #08245A;\r\n\r\n        &::after {\r\n          content: \"\";\r\n          display: block;\r\n          height: 8px;\r\n          width: 60px;\r\n          background: #08245A;\r\n          margin: .7rem auto 0;\r\n          border-radius: 20px;\r\n        }\r\n      }\r\n    }\r\n\r\n    .content-body {\r\n      margin: 3rem auto 0;\r\n      max-width: 1200px !important;\r\n    }\r\n  }\r\n}\r\n\r\n.text-ellipsis-100px{\r\n  max-width: 100px;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n  display: inline-block;\r\n  margin-left: .5rem;\r\n}\r\n","// Color palette\r\n$color-blue-light: #d0dbff;\r\n$color-blue: #354e80;\r\n$color-blue-dark: #1c2f56;\r\n\r\n$color-sky: #e0e7ff;\r\n\r\n$color-yellow-light: #fffdef;\r\n$color-yellow: #fae205;\r\n\r\n$color-black-30: #e1e2e2;\r\n\r\n$section-heading-font-size: 2.1rem;\r\n$page-title: 2.2rem;\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
